// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__bZKkg","scrollStub":"styles_scrollStub__mZhcu","footer":"styles_footer__iK2vv","content":"styles_content__ID_gC"};